export default __webpack_public_path__ + "static/media/twitter.eda40f4a.svg";